<template>
  <div>
    <Back :backText="$t('Take_practice_test')" @goBackRoute="goBackRoute"></Back>
    <!-- top -->
    <div class="about_top">
      <level :testType="computedTestType"></level>
      <div class="about_btn">
        <div v-if="!isHideResource" class="about_btn_left" @click="goLearnResource">
          {{ $t('Learning_resources') }}
        </div>
        <div v-if="!isHideFreePractice" class="about_btn_left" @click="clickFreePractice">
          {{ $t('free_practice_title') }}
        </div>
        <div class="about_btn_right" @click="takePractice">{{ $t('Take_practice_test') }}</div>
      </div>
    </div>
    <!-- change card -->
    <div class="tabs_box">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :name="item.name" v-for="(item, index) in tabArr" :key="index">
          <div slot="label" class="tabs_label_item">
            <SvgIcon
              :type="activeName === item.name ? item.selcted : item.name"
              class="icon-24"
            ></SvgIcon>
            <span :class="['tabs_label_text', activeName === item.name ? 'selected_text' : '']">{{
              labelName(item.label)
            }}</span>
          </div>
          <component
            :is="activeName"
            :level_contents="level_contents"
            :segments="segments"
          ></component>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog
      class="practice-root"
      :visible="freePracticeDialogVisible"
      width="1024px"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <FreePractice
        v-if="freePracticeDialogVisible"
        @closeDialog="freePracticeDialogVisible = false"
      ></FreePractice>
    </el-dialog>
  </div>
</template>
<script>
import SvgIcon from '@/components/SvgIcon.vue'
import level from './components/level'
import Description from './components/description'
import Test from './components/testFormat'
import Vocabulary from './components/vocabulary'
import { mapState, mapGetters } from 'vuex'
import Back from '@/components/common/Back'
import analytics from '@/utils/AnalyticsCenter'
import { pathUrl } from '@/config'
import { hideResourceList, getTestType, hideVocabulary } from '@/utils/hskTool'
import FreePractice from './components/freePractice'
export default {
  components: {
    level,
    SvgIcon,
    Description,
    Test,
    Vocabulary,
    Back,
    FreePractice,
  },
  data() {
    return {
      activeName: 'Description',
      tabArr: [
        {
          name: 'Description',
          selcted: 'Descriptioned',
          label: 'Description',
          icon: '',
        },
        {
          name: 'Test',
          selcted: 'Tested',
          label: 'Test_format',
        },
        {
          name: 'Vocabulary',
          selcted: 'Vocabularyed',
          label: 'Vocabulary',
        },
      ],
      level_contents: [], //description
      segments: [], //test format
      routeTypeName: '',
      level: '', // hsk1
      freePracticeDialogVisible: false,
    }
  },
  computed: {
    ...mapState({
      levelActive: (state) => state.level.levelActive,
      isGrading: (state) => state.grade.isGrading,
      levelType: (state) => state.level.levelType,
      levelActiveIndex: (state) => state.level.levelActiveIndex,
      levelList: (state) => state.level.levelList,
    }),
    ...mapGetters('level', {
      levelTypeName: 'levelTypeName',
    }),
    // 试卷服务端等级
    computedLevelId() {
      let level_num = 1
      if (this.$route.query.level && this.$route.query.level.match(/\d+/)) {
        level_num = +this.$route.query.level.match(/\d+/)[0]
      }
      let level_type = this.getLevelTypeByRoute()
      let levelList = this.levelList.find((item) => item.level_type == level_type)
      return levelList?.levels.find((item) => level_num == item.level_id)?.id || null
    },
    // 试卷类型1是hsk 2是hskk 3是yct
    computedTestType() {
      return this.getLevelTypeByRoute()
      // return Number(this.levelType || localStorage.getItem('LevelType'))
    },
    isHideResource() {
      return hideResourceList.some((item) => item === this.level)
    },
    isHideFreePractice() {
      return hideVocabulary.some((item) => item === this.level)
    },
  },
  mounted() {
    this.routeTypeName = this.getLevelTypeNameByRoute()
    this.level = this.$route.query.level
    // 隐藏字典
    if (hideVocabulary.some((item) => item === this.level)) {
      this.tabArr.splice(2, 1)
    }
  },
  methods: {
    getLevelTypeNameByRoute() {
      let path = window.location.pathname || this.$route.path
      return path.split('/')[1]
    },
    getLevelTypeByRoute() {
      let typestr = this.getLevelTypeNameByRoute()
      return getTestType(typestr)
    },
    labelName(label) {
      return this.$t(label)
    },
    goBackRoute() {
      let mixpanelParams = {
        exam_type: this.segments.level_name,
      }
      analytics.logEvent('hskweb_abtlevelback_click', mixpanelParams)
      // this.$router.replace(`/${this.levelTypeName || 'hsk'}/index`)
      this.$router.push({
        path: `/${this.routeTypeName || 'hsk'}/tests`,
        query: {
          level: `${this.$route.query.level}`,
        },
      })
    },
    // 获取介绍信息
    getIntroduce() {
      window.utilV2.getData(
        window.ApiPath.get_level_detail_new,
        { level_id: this.computedLevelId },
        (data) => {
          console.log('接口返回', data)
          this.level_contents = [data.level_contents[0], data.level_contents[2]]
          this.segments = data
          console.log('segments', this.segments)
          analytics.logEvent('hskweb_abtlevel_view', {
            exam_type: this.segments.level_name,
          })
        },
        null,
        {
          authorization: true,
          showLoading: false,
        }
      )
    },
    takePractice() {
      let mixpanelParams = {
        exam_type: this.segments.level_name,
      }
      analytics.logEvent('hskweb_abtleveltomock_click', mixpanelParams)
      // this.$router.push({
      //   path: `/${this.levelTypeName || 'hsk'}/index`,
      // })
      this.$router.push({
        path: `/${this.routeTypeName || 'hsk'}/tests`,
        query: {
          level: `${this.$route.query.level}`,
        },
      })
    },
    clickFreePractice() {
      this.freePracticeDialogVisible = true
    },
    goLearnResource() {
      let mixpanelParams = {
        exam_type: this.segments.level_name,
      }
      analytics.logEvent('hskweb_abtlevelresource_click', mixpanelParams)
      window.open(pathUrl.WOHUI)
    },
    handleClick() {
      console.log('切换=', this.activeName)
      let mixpanelParams = {
        exam_type: this.segments.level_name,
        type: this.activeName == 'Test' ? 'Test format' : this.activeName,
      }
      analytics.logEvent('hskweb_abtlevelswitch_click', mixpanelParams)
    },
  },
  watch: {
    computedLevelId: {
      handler(val) {
        if (val !== null) this.getIntroduce()
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>
<style scoped lang="scss">
.about_top {
  width: 1200px;
  height: 271px;
  border-radius: 12px;
  border: 1px solid var(--Wohui-BG-2, #efeff1);
  background: var(--Wohui-White, #fff);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  .about_btn {
    display: flex;
    margin-top: 35px;
    &_left {
      min-width: 254px;
      padding: 10px 24px;
      color: #2c2f46;
      text-align: center;
      font-size: 16px;
      font-weight: 700;
      border-radius: 4px;
      border: 0.5px solid var(--Wohui-Grey-3, #b5b5be);
      background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 100%), #fff;
      margin-right: 31px;
      cursor: pointer;
    }
    &_right {
      min-width: 254px;
      padding: 10px 24px;
      color: var(--Wohui-White, #fff);
      text-align: center;
      font-size: 16px;
      font-weight: 700;
      border-radius: 4px;
      background: #faae56;
      cursor: pointer;
    }
  }
}
.tabs_box {
  width: 1200px;
  min-height: 460px;
  border-radius: 12px;
  border: 1px solid var(--Wohui-BG-2, #efeff1);
  background: var(--Wohui-White, #fff);
  margin-top: 19px;
  padding: 33px 26px;
  .tabs_label_item {
    display: flex;
    align-items: center;
  }
  .tabs_label_text {
    color: #b5b5be;
    font-size: 18px;
    font-weight: 600;
    margin-left: 6px;
  }
  .selected_text {
    color: #696974;
    font-size: 18px;
    font-weight: 600;
    margin-left: 6px;
  }
}
.selected {
  color: red;
}
::v-deep .el-tabs__active-bar {
  width: 119px;
  height: 4px;
  background: #2c2f46;
  border-radius: 8px 8px 0px 0px;
}

::v-deep .el-tabs__header {
  margin: 0 0 31px;
}
.practice-root {
  ::v-deep .el-dialog__body {
    padding: 0 !important;
  }

  ::v-deep .el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-height: calc(100% - 70px);
    // max-width: calc(100% - 60px);
  }
  .el-dialog .el-dialog_body {
    flex: 1;
    overflow: auto;
  }
}
</style>
